import Cookies from 'js-cookie';
import { Route, Redirect } from 'react-router-dom';

const LoggedInRoute = ({ component: Component, ...rest }) => (
  <Route
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...rest}
    render={(props) =>
      Cookies.get('customerToken') ? (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: '/profile/login',
            state: { from: props.location }
          }}
        />
      )
    }
  />
);

export default LoggedInRoute;
